<template>
  <b-card
    align="left"
    class="booking-technician-card side-card"
    :class="{ 'has-positions': areTherePositions }"
    header-tag="header"
    no-body
  >
    <template #header>
      <b-row>
        <b-col>
          <h5>Pendientes</h5>
        </b-col>
      </b-row>
      <b-row>
        <b-col>
          <div class="position-wrapper" v-if="!areTherePositions">
            <div>
              <strong>¡Vaya!</strong>
            </div>
            Parece que no tienes nada pendiente
          </div>
        </b-col>
      </b-row>
    </template>
    <b-card-body v-if="areTherePositions" class="position-list">
      <div v-for="position in positions" :key="position.getId">
        <BookingPositionSearchItem
          :position="position"
          @onClick="goToPosition"
        />
      </div>
      <div v-for="hardwarePosition in hardwarePositions" :key="hardwarePosition.id">
        <HardwareBookingPositionSearchItem
          :position="hardwarePosition"
          @onClick="goToHardwareBookingPosition"
        />
      </div>
    </b-card-body>
  </b-card>
</template>
<script>
import BookingPositionSearchItem from '@/components/BookingPosition/BookingPositionSearchItem'
import HardwareBookingPositionSearchItem from '@/components/HardwareBooking/HardwareBookingPositionSearchItem'

export default {
  name: 'BookingTechnicianPendingCard',
  components: { HardwareBookingPositionSearchItem, BookingPositionSearchItem },
  data () {
    return {
      positions: [],
      hardwarePositions: [],
      baseUrl: process.env.VUE_APP_IMAGE_API_URL
    }
  },
  created () {
    this.loadData()
  },
  computed: {
    areTherePositions () {
      return this.positions.length > 0 && this.hardwarePositions.length
    }
  },
  methods: {
    loadData () {
      this.$store.dispatch('getPositionPending')
        .then((res) => {
          this.positions = res
        })
      this.$store.dispatch('hardwarePosition/getHardwarePositionPending')
        .then((res) => {
          this.hardwarePositions = res
        })
    },
    goToPosition (id) {
      this.$router.push({
        name: 'positions-pending-position',
        params: {
          id: id
        }
      })
    },
    goToHardwareBookingPosition (id) {
      this.$router.push({
        name: 'positions-pending-hardware-position',
        params: {
          id: id
        }
      })
    }
  }
}
</script>
<style lang="less">
  @import 'booking-techician.less';
  .position-contents {
    .business-name {
      cursor: pointer;
    }
  }
  .btn-outline {
    outline: none;
    img {
      outline: none;
    }
  }
  .position-wrapper {
    margin-top: 1.3rem;
    margin-bottom: 6.25rem;
  }
</style>
